import React, { useState } from "react";
import { Link, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Zap, UserPlus } from "lucide-react";
import { toast } from "sonner";

export default function Register() {
  const { user, register, error } = useAuth();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  if (user && user !== false) return <Navigate to="/" replace />;

  async function submit(e) {
    e.preventDefault();
    setBusy(true);
    const ok = await register(name, email, password);
    setBusy(false);
    if (ok) toast.success("Hoş geldiniz!");
  }

  return (
    <div className="min-h-screen grid place-items-center bg-[#090D14] p-8">
      <form onSubmit={submit} className="w-full max-w-md space-y-6" data-testid="register-form">
        <div className="flex items-center gap-3 justify-center mb-6">
          <div className="w-11 h-11 rounded-lg bg-amber-500/20 border border-amber-500/40 grid place-items-center">
            <Zap className="w-6 h-6 text-amber-400" />
          </div>
          <div>
            <div className="font-bold text-lg">AVES ELEKTRİK</div>
            <div className="text-[10px] mono uppercase tracking-[0.3em] text-amber-400/80">Otomasyon</div>
          </div>
        </div>

        <div>
          <h2 className="text-3xl font-bold tracking-tight">Yeni hesap oluştur</h2>
          <p className="text-sm text-slate-400 mt-2">Aves Finans platformuna katılın.</p>
        </div>

        <div className="space-y-4">
          <div>
            <Label>Ad Soyad</Label>
            <Input value={name} onChange={(e) => setName(e.target.value)} required data-testid="register-name" className="mt-1.5 bg-[#111723] border-white/10 h-11" />
          </div>
          <div>
            <Label>E-posta</Label>
            <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="register-email" className="mt-1.5 bg-[#111723] border-white/10 h-11" />
          </div>
          <div>
            <Label>Şifre (en az 6 karakter)</Label>
            <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={6} data-testid="register-password" className="mt-1.5 bg-[#111723] border-white/10 h-11" />
          </div>
        </div>

        {error && (
          <div className="rounded-lg border border-red-500/30 bg-red-500/10 text-red-200 text-sm px-4 py-2.5" data-testid="register-error">
            {error}
          </div>
        )}

        <Button type="submit" disabled={busy} data-testid="register-submit-btn" className="w-full h-11 bg-amber-500 hover:bg-amber-400 text-black font-semibold">
          <UserPlus className="w-4 h-4 mr-2" />
          {busy ? "Oluşturuluyor..." : "Kayıt Ol"}
        </Button>

        <div className="text-center text-sm text-slate-400">
          Zaten hesabınız var mı?{" "}
          <Link to="/login" className="text-amber-400 hover:underline" data-testid="link-login">Giriş yapın</Link>
        </div>
      </form>
    </div>
  );
}
